const NAMESPACE = "automationProgramDataStore";

const KEYS = {
    Form: "Form",
    Status: "Status",
    Scheduled: "Scheduled",
    Inquiry: "Inquiry",
    Channel: "Channel",
    ESignatureEnvelope: "ESignatureEnvelope",

    unknownEntityMessage: "unknownEntityMessage",
    unknownActionMessage: "unknownActionMessage"
};

const MESSAGES = {
    [KEYS.Form]: { value: "Form", comment: "Name for form trigger type" },
    [KEYS.Status]: { value: "Status", comment: "Name for status trigger type" },
    [KEYS.Scheduled]: { value: "Scheduled", comment: "Name for scheduled trigger type" },
    [KEYS.Inquiry]: { value: "Inquiry", comment: "Name for inquiry trigger type" },
    [KEYS.Channel]: { value: "Channel", comment: "Name for channel trigger type" },
    [KEYS.ESignatureEnvelope]: { value: "eSignature Envelope", comment: "Name for esignature envelope trigger type" },

    [KEYS.unknownEntityMessage]: {
        value: "UNKNOWN",
        comment: "Shown to indicate that we could not find a matching entity (field, signal, attachment, etc)"
    },
    [KEYS.unknownActionMessage]: {
        value: "Do Nothing",
        comment: "Shown to indicate that we could not find a matching rule type and will do nothing."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
